module.exports = __webpack_public_path__ + "assets-cabinet/img/no-photo.3b4efe08.svg";